import React, { Component } from 'react';
import { Helmet } from "react-helmet";

class Partners extends Component {
  componentDidMount() {
    document.getElementById('root').classList.remove('welcome');
    document.getElementById("root").classList.remove("affiliate");
    document.getElementById('foo').classList.add('overflow');
  }
  render() {
    return (
      <div className="sub-page">
        <Helmet>
          <title>STech - Our Partners</title>
          <meta name="description" content="STech - Our Partners pages" />
        </Helmet>
        <header className="clearfix fadeInUp">
          <div className="container">
            <div className="left"></div>
            <div className="right">
              <h1>Our Partners</h1>
              <h2>Building trust and creating reward</h2>
            </div>
          </div>
        </header>

        <section className="clearfix fadeInUp">
          <div className="container partners">
            <div className="left"></div>
            <div className="right">
              <div className="content">Building partnerships with trust and long-term reward is one of the core values of our company.
      STech is a hi-tech, fast-paced company but above all we create business partnerships that grow over
      time.
        <br /><br />Below, we present a selection of our existing clients and their software products...
        </div>
            </div>
          </div>
        </section>

        {/* <section className="clearfix foo-1 wow fadeInUp" data-wow-duration="0.5s" data-wow-delay="0.15s">
    <div className="container partners clearfix">
      <div className="left border">
      </div>
      <div className="right border">
        <h4>International Coverage</h4>
        <h2>Multiple Payment Types</h2>
      </div>
    </div>
    <div className="container partners clearfix">
    <span>Major debit and credit cards mixed with the newest payment providers for multi-currency and multi-lingual solutions:</span>      <div className="logo">

        <img src="../images/partners/icon-logo-paymetn-visa-2.svg" alt="Visa"/>
        <img src="../images/partners/icon-logo-payment-mastercard-2.svg" alt="MasterCard"/>
        <img src="../images/partners/icon-logo-payment-amex-2.svg" alt="Amex"/>
        <img src="../images/partners/icon-logo-payment-diners-2.svg" alt="Diners"/>
        <img src="../images/partners/icon-logo-payment-discover-2.svg" alt="Discover"/>
        <img src="../images/partners/icon-logo-payment-jcb-2.svg" alt="JCB"/>

      </div>
      <span>Stored-value digital wallets:</span>
      <div className="logo offset-2">
        <img src="../images/partners/shape-57-copy.svg" alt="PayPal"/>
        <img src="../images/partners/neteller.svg" alt="Neteller"/>
        <img src="images/partners/group-7.svg" alt="PaysafeCard"/>
        <img src="../images/partners/fill-1.svg" alt="Skrill"/>
        <img src="../images/partners/group-8.svg" alt="Trustly"/>

      </div>
      <span>Pass-through digital wallets</span>
      <div className="logo offset-3">
        <img src="../images/partners/group-9.svg" alt="G Pay"/>
        <img src="../images/partners/shape_26.svg" alt="Visa Ceckout"/>
        <img src="../images/partners/shape_25.svg" alt="Apple Pay"/>

      </div>
    </div>
  </section> */}


        <section className="clearfix fadeInUp">
          <div className="container partners clearfix">
            <div className="left border">
            </div>
            <div className="right border">
              <h4>Casino & Virtual Sports Content</h4>
              <h2>Game Providers</h2>
              <h3>Offer 1,500+ Casino, Live Casino & Virtual Sports games. Partners include NetEnt, Microgaming, Kiron & other leading providers.</h3>
            </div>
          </div>
          <div className="container partners clearfix">
            <div className="logo">
              <img src="../images/partners/evolotion-gaming.svg" alt="EvolutionGaming" />
              <img src="../images/partners/netent.svg" alt="NetEnt" />
              {/* <img src="../images/partners/microgaming.svg" alt="Microgaming" /> */}
              <img src="../images/partners/playson.svg" alt="Playson" />
              <img src="../images/partners/yggdrasil.svg" alt="Yggdrasil" />
              <img src="../images/partners/greentube.svg" alt="Green Tube" />
              <img src="../images/partners/redtiger.svg" alt="Red Tiger" />
            </div>
            {/* <div className="logo offset-3">
              <img src="../images/partners/ezugi.svg" alt="Ezugi" />
              <img src="../images/partners/xpg.svg" alt="Xpg" />
              <img src="../images/partners/betsoft.svg" alt="Betsoft" />
            </div> */}
          </div>
        </section>
      </div>
    );
  }
}

export default Partners
